import gql from "graphql-tag";

export const ADD_USER = gql`
  mutation createUser($username: String!, $photoUrl: String!) {
    createUser(username: $username, photoUrl: $photoUrl) {
      username
      photoUrl
      id
    }
  }
`;

export const GET_USERS = gql`
query {
  allUsers {
    id
    username
    photoUrl
    state
    lastDisconnection
    writing
  }
}
`;

export const GET_USER = gql`
query($username: String!) {
  allUsers(first: 1, filter: { username: $username }) {
    id
    username
    photoUrl
    state
    lastDisconnection
    writing
    theme
  }
}
`;

export const UPDATE_USER_STATE_AND_LAST_DISCONNECTION = gql`
mutation updateUser($state: State!, $lastDisconnection: DateTime!, $id: ID!) {
  updateUser(state: $state, lastDisconnection: $lastDisconnection, id: $id) {
    id
    state
    lastDisconnection
  }
}
`;

export const UPDATE_USER_THEME = gql`
mutation updateUser($theme: Theme!, $id: ID!) {
  updateUser(theme: $theme, id: $id) {
    id
    theme
  }
}
`;

export const UPDATE_USER_WRITING = gql`
mutation updateUser($writing: Boolean!, $id: ID!) {
  updateUser(writing: $writing, id: $id) {
    id
    writing
  }
}
`;

// Searches messages between users by username
export const GET_MESSAGES_BETWEEN_USERS = gql`
query($from: String!, $to: String!) {
  allMessages(filter: {OR: [ 
    {AND: [{ from: $from }, { to: $to }]} , 
    {AND: [{ from: $to }, { to: $from }]} 
  ]}) {
    id
    text
    date
    from
    to
  }
}
`;

export const ADD_MESSAGE = gql`
mutation createMessage($from: String!, $to: String!, $text: String!, $date: DateTime!) {
  createMessage(from: $from, to: $to, text: $text, date: $date) {
    from
    to
    text
    date
  }
}
`;

export const MESSAGE_SUBSCRIPTION = gql`
subscription newMessagesForUser($from: String!, $to: String!) {
  Message(
    filter: {
      mutation_in: [CREATED]
      node: {
        from: $from,
        to: $to
      }
    }
  ) {
    mutation
    node {
      text
      from
      to
      date
    }
  }
}
`



// WEBPACK FOOTER //
// ./src/query/queries.js